export const compareDates = (date1?: string, date2?: string) => {
    if (!date1 || !date2) return true;
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);
    return firstDate > secondDate;
}